<ngb-pagination
  [disabled]="disabled"
  [boundaryLinks]="boundaryLinks"
  [directionLinks]="directionLinks"
  [ellipses]="ellipses"
  [rotate]="rotate"
  [collectionSize]="collectionSize"
  [maxSize]="(deviceMaxSize$ | async) || 1"
  [pageSize]="(devicePageSize$ | async) || 1"
  [(page)]="page"
>
  <ng-template #previous ngbPaginationPrevious>
    @if (!overrides.prevText || (isMobile$ | async)) {
      <fa-icon class="icon" icon="arrow-left"></fa-icon>
    }
    @if (overrides.prevText && (isMobile$ | async) === false) {
      {{ overrides.prevText }}
    }
  </ng-template>
  <ng-template #next ngbPaginationNext>
    @if (!overrides.nextText || (isMobile$ | async)) {
      <fa-icon class="icon" icon="arrow-right"></fa-icon>
    }
    @if (overrides.nextText && (isMobile$ | async) === false) {
      {{ overrides.nextText }}
    }
  </ng-template>
  @if (showPaginationSummary$ | async) {
    <ng-template #pages ngbPaginationPages let-page let-pages="pages">
      @if (pages.length > 0) {
        <li class="ngb-custom-pages-item">
          <span>{{
            overrides.summaryText ?? ''
              | interpolate
                : {
                    mode: 'rich_text',
                    variables: { page: page, pages: pages.length },
                  }
          }}</span>
        </li>
      }
    </ng-template>
  }
</ngb-pagination>
